// Purpose: Auth API calls — login
// Caller: authAction
// Dependencies: utils/xhr
// Main Functions: login
// Side Effects: HTTP POST /login

import { xhr } from 'utils'

export const login = (data) => xhr.post('/login', data)
